(function($, App, Utils){
  'use strict';

  Utils.add('Fixes', {

    fixSwitches: function() {
      // Spring framework is idiot enough to make "for" attribute
      // mandatory for labels...
      // Now, since chrome decided to search the "ID" specified in "for" attribute
      // OUTSIDE the label tag (which is reasonable enough), "native label click"
      // is not fired, thus it's impossible to select a checkbox (nor a radio,
      // off course).
      // Thankyou Spring.
      $('.checkbox, .radio').find('label').removeAttr('for');
    },

    init: function() {
      this.fixSwitches();
    }
  });

})(jQuery, window.App, window.App.Utils);
